import { useCallback } from 'react'
import { debounce } from 'lodash'

export function useDebounce(callback: (...args: any[]) => void, delay = 500) {
  return useCallback(debounce(callback, delay), [])
}
